// TA Local Business Types and Interfaces

export interface TALocalDescription {
  "Street Address": string;
  "Phone Number": string;
  "Email": string;
  "Website": string;
  "Product Category": string;
  "Offer": string;
  "logoUrl": string;
  "imageUrls"?: string[];
}

export interface TALocalDto {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  description: string; // JSON string
  poiTypeId: number;
  introductionThumbnail: string;
  region: string;
  assetId?: number;
  objectId?: number;
  poiStatus: number;
  approvalStatus: number;
  rejectionReason?: string | null;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
  mapVersion?: number;
  // Parsed description for easier access
  parsedDescription?: TALocalDescription;
}

export interface CreateTALocalRequest {
  name: string;
  latitude: number;
  longitude: number;
  region: string;
  introductionThumbnail: string;
  streetAddress: string;
  phoneNumber: string;
  email: string;
  website: string;
  productCategory: string;
  offer: string;
  logoUrl: string;
  imageUrls?: string[];
  poiStatus?: number;
  approvalStatus?: number;
}

export const APPROVAL_PENDING = 0;
export const APPROVAL_APPROVED = 1;
export const APPROVAL_REJECTED = 2;

export interface UpdateTALocalRequest {
  name?: string;
  latitude?: number;
  longitude?: number;
  region?: string;
  introductionThumbnail?: string;
  streetAddress?: string;
  phoneNumber?: string;
  email?: string;
  website?: string;
  productCategory?: string;
  offer?: string;
  logoUrl?: string;
  imageUrls?: string[];
  poiStatus?: number;
}

export interface TALocalListResponse {
  locals: TALocalDto[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
}

/** What approving a listing will charge, as the Admin API works it out. */
export type PromoCodeStatus =
  | 'None'
  | 'Active'
  | 'NotRecognised'
  | 'AlreadyApplied'
  | 'CouldNotCheck';

export interface ApprovalChargePreview {
  currency: string;
  listPriceCents: number | null;
  promoCode: string | null;
  codeStatus: PromoCodeStatus;
  discountSummary: string | null;
  /** Null when it could not be worked out — show the caveat, never a guess. */
  chargeNowCents: number | null;
  chargeOnRenewalCents: number | null;
  autoRenew: boolean;
  /** Null when Stripe would not say — not the same as no. */
  cardOnFile: boolean | null;
  /** What would stop the approval, in the words the button would use. */
  refusal: string | null;
  caveat: string | null;
}

export interface TALocalStatsDto {
  totalLocals: number;
  activeLocals: number;
  deletedLocals: number;
  byCategory: { [key: string]: number };
  byRegion: { [key: string]: number };
}

export const PRODUCT_CATEGORIES = [
  'Retail',
  'Food & Beverage',
  'Accommodation',
  'Transport',
  'Health & Wellbeing',
  'Leisure'
];

export const NZ_REGIONS = [
  'Northland',
  'Auckland',
  'Waikato',
  'Bay of Plenty',
  'Gisborne',
  'Hawke\'s Bay',
  'Taranaki',
  'Manawatu-Wanganui',
  'Wellington',
  'Tasman',
  'Nelson',
  'Marlborough',
  'West Coast',
  'Canterbury',
  'Otago',
  'Southland'
];